// extracted by mini-css-extract-plugin
export default {"addButton":"addItemButton_addButton__oTNBP"};